import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {UserAutocompleteComponent} from './user-autocomplete.component';

@NgModule({
  imports: UserAutocompleteModule.IMPORTS,
  declarations: UserAutocompleteModule.DECLARATIONS,
  exports: UserAutocompleteModule.DECLARATIONS
})
export class UserAutocompleteModule {
  public static readonly IMPORTS: any[] = [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule
  ];

  public static readonly DECLARATIONS: any[] = [UserAutocompleteComponent];
}
